import { CONFIRM_TEXT } from '@/shared/config/confirm-text'
import { getRegexPassword } from '@/shared/lib/strings-utils'
import { LockOutlined, SafetyOutlined } from '@/shared/ui/icons'
import UiInput from '@/shared/ui/ui-input'
import UiFormModal from '@/shared/ui/ui-modal/UiFormModal'
import { notify } from '@/shared/ui/ui-notification'
// ds-guard-ignore: Form chưa có wrapper Ui* tương ứng, giữ antd trực tiếp
import { Form } from 'antd'
import { useState } from 'react'
import { useChangePassword } from '../hooks/useChangePassword'

interface FormValues {
  passOld: string
  pass: string
  rePass: string
}

interface ChangePasswordModalProps {
  open: boolean
  onClose: () => void
}

export default function ChangePasswordModal({ open, onClose }: Readonly<ChangePasswordModalProps>) {
  const [form] = Form.useForm<FormValues>()
  const [loading, setLoading] = useState(false)
  const { mutateAsync } = useChangePassword()

  const handleClose = () => {
    form.resetFields()
    onClose()
  }

  const handleFinish = async (values: FormValues) => {
    setLoading(true)
    try {
      await mutateAsync({
        oldPassword: values.passOld,
        newPassword: values.pass,
        confirmNewPassword: values.rePass,
      })
      notify.success('Đổi mật khẩu thành công')
      handleClose()
    } catch {
      // Lỗi API đã được Axios Interceptor tự động hiển thị toast
    } finally {
      setLoading(false)
    }
  }

  return (
    <UiFormModal
      open={open}
      form={form}
      isSubmitting={loading}
      onCancel={handleClose}
      onOk={() => form.submit()}
      okText="Cập nhật"
      cancelText={CONFIRM_TEXT.cancel}
      confirmLoading={loading}
      title="Đổi mật khẩu"
      size="sm"
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          label="Mật khẩu cũ"
          name="passOld"
          rules={[
            { required: true, message: 'Bạn chưa nhập mật khẩu cũ!' },
            { pattern: getRegexPassword(), message: 'Mật khẩu không đúng định dạng.' },
          ]}
        >
          <UiInput type="password" placeholder="Nhập mật khẩu cũ" prefixIcon={<LockOutlined />} />
        </Form.Item>
        <Form.Item
          label="Mật khẩu mới"
          name="pass"
          rules={[
            { required: true, message: 'Bạn chưa nhập mật khẩu mới!' },
            {
              pattern: getRegexPassword(),
              message:
                'Mật khẩu phải có tối thiểu 8 ký tự, ít nhất một chữ cái viết thường, một số và một ký tự đặc biệt.',
            },
          ]}
        >
          <UiInput type="password" placeholder="Nhập mật khẩu mới" prefixIcon={<LockOutlined />} />
        </Form.Item>
        <Form.Item
          label="Nhập lại mật khẩu mới"
          name="rePass"
          dependencies={['pass']}
          rules={[
            { required: true, message: 'Bạn chưa nhập lại mật khẩu mới!' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('pass') === value) return Promise.resolve()
                return Promise.reject(new Error('Mật khẩu nhập lại phải giống với mật khẩu mới!'))
              },
            }),
          ]}
        >
          <UiInput
            type="password"
            placeholder="Nhập lại mật khẩu mới"
            prefixIcon={<SafetyOutlined />}
          />
        </Form.Item>
      </Form>
    </UiFormModal>
  )
}
